module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderManager-sec default-bg"
  }, [_c('normalBar', {
    attrs: {
      "title": "我的订单",
      "path": "/Mine"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-tab"
  }, [_c('span', {
    staticClass: "tab-item",
    class: {
      'active': _vm.status == 0
    },
    on: {
      "click": function($event) {
        _vm.tabChange(0)
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('span', {
    staticClass: "tab-item",
    class: {
      'active': _vm.status == 1
    },
    on: {
      "click": function($event) {
        _vm.tabChange(1)
      }
    }
  }, [_vm._v("待付款")]), _vm._v(" "), _c('span', {
    staticClass: "tab-item",
    class: {
      'active': _vm.status == 2
    },
    on: {
      "click": function($event) {
        _vm.tabChange(2)
      }
    }
  }, [_vm._v("待收货")])]), _vm._v(" "), (!_vm.loading) ? _c('div', [(_vm.orderList.length <= 0) ? _c('div', {
    staticClass: "empty"
  }, [_c('p', [_vm._v("您还没有订单哦")])]) : _c('div', {
    ref: "wrapper",
    staticClass: "order-list-sec",
    style: ({
      height: _vm.wrapperHeight + 'px'
    })
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "bottom-method": _vm.bottomTop,
      "bottom-all-loaded": _vm.allLoaded,
      "autoFill": false
    },
    on: {
      "bottom-status-change": _vm.handleBottomChange
    }
  }, [_c('div', {
    staticClass: "bg-grey-sec"
  }, _vm._l((_vm.orderList), function(item, itemIndex) {
    return _c('div', {
      staticClass: "order-items"
    }, [_c('div', {
      staticClass: "gift-sec order-sec"
    }, [_c('div', {
      staticClass: "gift-header"
    }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t订单号：" + _vm._s(item.merchantId) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "gift-body"
    }, _vm._l((item.merchantOrderDetailVos), function(proList, index) {
      return _c('div', {
        staticClass: "gift-item"
      }, [_c('div', [(proList.merchantOrderDetailGoodsVos.length > 1) ? _c('div', {
        staticClass: "media",
        on: {
          "click": function($event) {
            _vm.goOrderDetails(item.merchantId)
          }
        }
      }, [_c('div', {
        staticClass: "media-left img-list"
      }, [_c('div', {
        staticClass: "img-wrap"
      }, _vm._l((proList.merchantOrderDetailGoodsVos), function(order, orIndex) {
        return _c('img', {
          attrs: {
            "src": !!order.imgUrl ? order.imgUrl : _vm.defaultIimgUrl
          }
        })
      }))]), _vm._v(" "), _c('div', {
        staticClass: "media-right"
      }, [_c('div', [_c('p', [_vm._v("礼盒" + _vm._s(index + 1))]), _vm._v(" "), _c('p', {
        staticClass: "text-red"
      }, [_vm._v(_vm._s(proList.userOrderStatusDesc))])])])]) : _vm._l((proList.merchantOrderDetailGoodsVos), function(order) {
        return _c('div', {
          staticClass: "media",
          on: {
            "click": function($event) {
              _vm.goOrderDetails(item.merchantId)
            }
          }
        }, [_c('div', {
          staticClass: "media-left"
        }, [_c('img', {
          attrs: {
            "src": !!order.imgUrl ? order.imgUrl : _vm.defaultIimgUrl,
            "alt": ""
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_c('p', {
          staticClass: "m-title"
        }, [_c('span', [_vm._v(_vm._s(order.showGoodsName) + " "), _c('span', {
          staticClass: "text-grey"
        }, [_vm._v(_vm._s(order.skuProperty))])])]), _vm._v(" "), _c('p', {
          staticClass: "extraInfo"
        }, [_vm._v("生日牌：" + _vm._s(order.chocoBoard))]), _vm._v(" "), _c('p', {
          staticClass: "extraInfo"
        }, [_vm._v("祝福贺卡：" + _vm._s(order.greetingCard))])]), _vm._v(" "), _c('div', {
          staticClass: "media-right"
        }, [_c('div', [_c('p', [_vm._v("礼盒" + _vm._s(index + 1))]), _vm._v(" "), _c('p', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(proList.userOrderStatusDesc))])])])])
      }), _vm._v(" "), (proList.userOrderStatus == 15 || proList.userOrderStatus == 16) ? _c('div', {
        staticClass: "order-foot"
      }, [_c('button', {
        staticClass: "default-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.checkRefundDetails(proList.orderCode)
          }
        }
      }, [_vm._v("退款详情")])]) : _vm._e(), _vm._v(" "), (proList.userOrderStatus == 7 || proList.userOrderStatus == 8) ? _c('div', {
        staticClass: "order-foot"
      }, [_c('button', {
        staticClass: "default-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.checkReceive(proList.orderCode, itemIndex, index)
          }
        }
      }, [_vm._v("确认收货")])]) : _vm._e()], 2)])
    })), _vm._v(" "), (item.userOrderStatus == 1) ? _c('div', {
      staticClass: "order-foot"
    }, [_c('span', [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t¥" + _vm._s(_vm._f("filterPrice")(item.totalOrderAmount)) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('countDown', {
      attrs: {
        "index": itemIndex,
        "timer": item.payTime,
        "payNo": item.payNo
      },
      on: {
        "timerOut": _vm.timerOuts
      }
    })], 1)]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "mint-loadmore-bottom",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomStatus !== 'loading'),
      expression: "bottomStatus !== 'loading'"
    }],
    class: {
      'rotate': _vm.bottomStatus === 'pull'
    }
  }, [_vm._v("上拉加载更多")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomStatus === 'loading'),
      expression: "bottomStatus === 'loading'"
    }]
  }, [_vm._v("Loading...")])])])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c5dd2d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/orderManager.vue
// module id = 580
// module chunks = 1